import React, { useState, useEffect,forwardRef } from "react";
import "./AuditDetailsUpdate.css"
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getAuditDetails ,updateAuditDetails,extandAudit,downloadAuditDetailsdata} from "../../../../services/audit_redux/audit_actions/Audit.action";
import { GoChevronRight } from "react-icons/go";
import auditbreadcrumb_icon from "../../../../assets/audit_assets/Create_Audit/auditbreadcrumb_icon.png";
import mainIcon from "../../../../assets/audit_assets/audit_details/main_icon.png";
import headerIcon from "../../../../assets/audit_assets/audit_details/headerIcon.png";
import { FaEye } from "react-icons/fa";
import { FaUpload } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import Button from '@mui/material/Button';
import AttachmentViewer from "../../../reUsableTemplates/fileviewer/AttachmentViewer";
import intomarkIcon from "../../../../assets/audit_assets/Audit_vendor/intomarkIcon.png"
import {fetchClientWiseMapTemplate} from './../../../../services/audit_redux/audit_actions/TemplateMap.action'
import Select from "react-select";
import { use } from "react";
import MultiSelect from "../../../reUsableTemplates/multiSelectDropdown/MultiSelect";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
function AuditDetailsUpdate({Action, setLoading, showSnackbar }) {
  const navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useDispatch();
  // const [auditData, setAuditData] = useState([]); 
  const [formValues, setFormValues] = useState([]);
  const [changedRows, setChangedRows] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [openCompleteAlert,setOpenCompleteAlert] = useState(false);
  const [updateAuditView,setUpdateAuditView] = useState(false);
  const [templatedata, setTemplatedata] = useState([]);
  const [remainderDates, setRemainderDates] = useState([]);
  const [currentMonthIndex, setCurrentMonthIndex] = useState(0);
  const [months, setMonths] = useState([]);
  const [groupedData, setGroupedData] = useState([]);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const today = new Date().toISOString().split("T")[0];
  const [currentStatus , setCurrentStatus] = useState('Audit')
  const [auditID , setAuditID] = useState(null)
  const UpdateFormData ={
    id: id,
    audit_name: "",
    client_id:"",
    start_period: "",
    end_period: "",
    status:"Audit",
    validity_date:"",
    mail_reminder:[]
  }
  const [updateForm, setUpdateForm] = useState(UpdateFormData);
    const header = [
        // { key: "actId", value: "Act", icon: headerIcon },
        { key: "actName", value: "Act Name", icon: headerIcon },
        // { key: "section_id", value: "Section", icon: headerIcon },
        { key: "ruleName", value: "Rule", icon: headerIcon },
        { key: "ruleNumber", value: "Rule Number", icon: headerIcon },
        { key: "activityName", value: "Particulars", icon: headerIcon },
        { key: "Attachment", value: "Attachment", icon: headerIcon },
        { key: "remark", value: "Vendor Remark", icon: headerIcon }
    ]
    if (Action !== "View") {
        header.push(
            { key: "auditors_remark", value: "Remark", icon: headerIcon },
            { key: "status", value: "Status", icon: headerIcon }
        );
    }
  const fetchData = async () => {
    try {
      const response = await dispatch(getAuditDetails(id));
      setAuditID(response.data.audit_id);
      if(response.success){
        setCurrentStatus(response?.data?.stutus)
        const data = response?.data?.templates?.flatMap(t => t.activities) || [];
        const grouped = data.reduce((acc, item) => {
          if (!acc[item.period_month]) acc[item.period_month] = [];
          acc[item.period_month].push(item);
          return acc;
        }, {});
        
        const monthOrder = Object.keys(grouped).sort();
          setUpdateForm({
            ...updateForm,
            audit_name: response?.data?.audit_name,
            client_id: response?.data?.client_id,
            start_period:  response?.data?.start_period,
            end_period:  response?.data?.end_period,
            validity_date: response?.data?.validity_date,
            mail_reminder: Array.isArray(response?.data?.mail_reminder)
              ? response.data.mail_reminder
                  .map(item => item?.date)
                  .filter(Boolean)
              : []
  
          })
        if (response?.data?.validity_date) {
          const range = getDateRange(today, response?.data?.validity_date);
          setRemainderDates(
            range.map((d) => ({
              label: d,
              value: d,
            }))
          );
        } else {
          setRemainderDates([]);
        }
        setGroupedData(grouped);
        setMonths(monthOrder);
        setCurrentMonthIndex(0);
        getTemplates(response?.data?.client_id);
        setFormValues(data.map(a => ({ id: a.id, auditors_remark: a.auditors_remark, status: a.status })));

      }
    } catch (err) {
      console.error("Failed to fetch audit data:", err);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dispatch]);

  const handleRemarkChange = (id, value) => {
    setFormValues(prev =>
      prev.map(f => (f.id === id ? { ...f, auditors_remark: value } : f))
    );

    setChangedRows(prev => ({
      ...prev,
      [id]: { ...(prev[id] || {}), auditors_remark: value }
    }));
  };
  const handleStatusChange = (id, value) => {
    setFormValues(prev =>
      prev.map(f => (f.id === id ? { ...f, status: value } : f))
    );

    setChangedRows(prev => ({
      ...prev,
      [id]: { ...(prev[id] || {}), status: value }
    }));
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    const action = e.nativeEvent.submitter.name;
    if(action === "save"){
      handlesubmitAudit(action);
    }else{
      setOpenCompleteAlert(true)
    }
  };
  const handlesubmitAudit = async(action)=>{
    setLoading(true);
    let status = ""
    if (action === "save") {
      status ="Auditor-In-progress"
    } else{
      status ="Completed"
    }
    const modifiedData = Object.entries(changedRows).map(([key, value]) => ({
      id: Number(key),
      auditors_remark:
        value.auditors_remark ??
        formValues.find(f => f.id === Number(key))?.auditors_remark ??
        "",
      status:
        value.status ??
        formValues.find(f => f.id === Number(key))?.status ??
        "Non-Compliance"
    }));
    const formData = new FormData();
    modifiedData.forEach(item => {
      formData.append("data[]", JSON.stringify({ id: item.id, auditors_remark: item.auditors_remark, status: item.status }));
      if (item.attachment) {
        formData.append(`attachment_${item.id}`, item.attachment);
      }
    });
    if (modifiedData.length === 0) {
      modifiedData.push(formValues[0]);
    }
    try {
      const datas = {
        data:modifiedData
      }
      const response = await dispatch(updateAuditDetails(status,datas));
      if(response.success){
        navigate('/audit-details', {
          state: { message: response.message || 'Audit details updated successfully!', type: 'success',statusData:status }
        });
        setLoading(false);

      }else{
        showSnackbar(response.message, 'warning');
        setLoading(false);
      }
    } catch (error) {
      showSnackbar('An error occurred', 'error');
      console.error(error);
      setLoading(false);
    }

  }

  const setOpenCompleteAlertFalse = ()=>{
    setOpenCompleteAlert(false);
  }
  const handleUpdateAuditData = ()=>{
    handlesubmitAudit("Completed");
    setOpenCompleteAlert(false);
  }
  // file view 
  
  const [showModal, setShowModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [fileId, setFileId] = useState(0);

  const handleEyeClick = (files,dataId) => {
    setFileId(dataId);
    const safeJson = files.replace(/\\/g, "/");
    setSelectedFiles(JSON.parse(safeJson));
    setShowModal(true);
  };
// update audit 

const getTemplates = async(client)=>{
  try {
    const response = await dispatch(fetchClientWiseMapTemplate(client));
    if(response.success){
      setTemplatedata(response.data[0]?.templates);
    }else{

    }

  } catch (error) {
    
  }
}
const templateOptions = templatedata.map((item) => ({
  value: item.template_id,
  label: item.template_name,
}));



const currentMonthdata = new Date().toISOString().slice(0, 7);
const currentMonth = months[currentMonthIndex];
const auditDataRaw = groupedData[currentMonth] || [];
useEffect(() => { 
  setSearchQuery("");
}, [currentMonthIndex]);

const auditData = Array.isArray(auditDataRaw)
  ? auditDataRaw.filter(item =>
      Object.values(item).some(value =>
        String(value).toLowerCase().includes(searchQuery.toLowerCase())
      )
    )
  : [];
const getDateRange = (start, end) => {
  const dates = [];
  let current = new Date(start);

  while (current <= new Date(end)) {
    dates.push(current.toISOString().split("T")[0]);
    current.setDate(current.getDate() + 1);
  }

  return dates;
};

const onSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  try {
    const data = {
      ...updateForm,
      mail_reminder: Array.isArray(updateForm.mail_reminder)
        ? updateForm.mail_reminder.map(date => ({
            date,
            reminder_sent: 0,
            sent_at: ""
          }))
        : []
      
    };
  const response = await dispatch(extandAudit(updateForm.id,data));
  if(response.success){
        navigate('/audit-details', {
          state: { message: response.message || 'Audit details updated successfully!', type: 'success',statusData:"Audit" }
        });
        setLoading(false);
  }else{
    showSnackbar(response.message, 'warning');
    setLoading(false);
  }
  }catch (error) {
    showSnackbar('An error occurred', 'error');
    console.error(error);
    setLoading(false);
  }
  
};
const downloadAuditCheckList = async () => {
  setLoading(true);
  try {
    const data = {
      titleName : "Audit Details",
      audit_id : auditID
      
    };
  const response = await dispatch(downloadAuditDetailsdata(data));
  if(response.success){
    setLoading(false);
    setUpdateAuditView(false);
    showSnackbar("Downloaded Checklist Successfully", 'success');

  }else{
    showSnackbar(response.message, 'warning');
    setLoading(false);
  }
  }catch (error) {
    showSnackbar('An error occurred', 'error');
    console.error(error);
    setLoading(false);
  }
}
  return (
    <div className='container-fluid'>
      <div className="row mt-4">
        <div className="col-md-12">
          <div className="create-audit-header d-flex ">
          <img src={auditbreadcrumb_icon} alt="" /><h5 className='breadcrumbdata text-white'>Audit 
          <span><GoChevronRight /></span>  
          <span className="breadcrumb-link"
                  onClick={() => navigate("/audit-details",{                    
                    state: {  statusData: currentStatus }
                  })}
                  style={{ cursor: "pointer", textDecoration: "underline" }}>
                     Audit Details
          </span>
          {Action === "View" &&
          <><span><GoChevronRight /></span>  Audit Details View</> }
          {Action === "Work" &&
          <><span><GoChevronRight /></span> Work Audit </> }
          {Action === "Complated" &&
          <><span><GoChevronRight /></span> Completed Audit Details</> }
          {Action === "Expired" &&
          <><span><GoChevronRight /></span> Expired Audit Details</> }
          </h5>
          </div>
          <div className="row">
            <div className='container-fluid vendorEditableTable-main-contaner '>
              <div className='row FormsTable-main mb-5'>
                <div className="table-header">
                  <div className="row d-flex">
                    <div className="col d-flex justify-content-between  pe-1">
                      <div className="title-data d-flex"><div className="table_main_img"
                      ><img src={mainIcon} alt="noImg" className='dataImg' /></div>
                        <p className="dataTitle">Audit Details</p> 
                        <div className="FormsTable-search-box position-relative">
                          <input
                            type="text"
                            className=""
                            placeholder="Search here..."
                            style={{
                              backgroundColor: "#f9fafb",
                              border: "none",
                              width: "250px"
                            }}
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                          />
                          <i
                          className="bi bi-search position-absolute"
                          style={{
                            top: "39%",
                            left: "20px",
                            transform: "translateY(-50%)",
                            color: "#9ca3af"
                          }}
                          ></i>
                        </div>
                      </div>
                      <div className='float-end d-flex'>             
                        {/* <button className={`formsTable_icon_btn`} onClick={handleDownloadSelected}><img src={download_icon} alt="noImg" className='download_icon p-0 m-0' /></button> 
                        <button className={`formsTable_icon_btn `}  onClick={handleDeleteSelected}><img src={delete_icon} alt="noImg" className='delete_icon p-0 m-0' /></button> */}
                        {/* <div className='formsTable_icon_btn'><img src={selected_icon} alt="" /></div>      */}
                          {/* <div className="formsTable_icon_btn" onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)}>
                            <img src={selected_icon} alt="" />
                            {showTooltip && (
                                <div className="tooltipww">
                                    Selected: {checkedItemCount}
                                </div>
                            )}
                        </div> */}
                        <div className="dataTotalEntries"><p>Total Entries :{auditData?.length}</p></div>
                        <div className="">
                          <button className="auditDetailsDownloadbtn" onClick={downloadAuditCheckList}>Download Check List</button>
                        </div>
                        <div className={`filter_or_createcomponentn d-flex `}>
                          <select
                            className="form-select"
                            value={currentMonthIndex}
                            onChange={(e) => setCurrentMonthIndex(Number(e.target.value))}
                          >
                            {months.map((m, index) => {
                              const [year, month] = m.split("-");
                              const shortMonth = new Date(`${year}-${month}-01`).toLocaleString("en-US", {
                                month: "short",
                              });

                              return (
                                <option key={m} value={index}>
                                  {shortMonth.toUpperCase()}-{year}
                                </option>
                              );
                            })}
                          </select>
                        </div>  
                      </div>
                    </div>
                      <div className="">
                      <div className="createAuditdiv d-flex justify-content-end">
                      </div>
                      <form onSubmit={handleSubmit}>
                        <div className='table-body bg-white p-0 table-roundedData mb-3 '>                        
                          <div
                          className={`table-responsive reuseableEditable `}
                          
                          >
                            <table className='table p-0 m-0' id='dataTable'>
                              <thead className="table-light auditDetailstHeader">
                                <tr>
                                  {header?.map((head) => (
                                    <th key={head.key}>
                                        {head.icon && <img src={head.icon} alt="" width="16" className="me-2" />}
                                        {head.value}
                                    </th>
                                  ))}
                                </tr>
                              </thead>
                              <tbody>
                                {auditData.length > 0 ? (
                                  auditData.map((row, i) => {
                                    const currentFile = formValues.find(f => f.id === row.id)?.attachment;
                                    const hasUploadedFile = !!currentFile;
                                    const existingFile = row.attachment;
                                    const uploadedCount = Array.isArray(existingFile)
                                    ? existingFile.length
                                    : typeof existingFile === "string" && existingFile.trim() !== ""
                                    ? existingFile.split(",").length
                                    : 0;
                                    return (
                                      <tr key={row.id}>
                                        {header?.map((head) => (
                                          <React.Fragment key={head.key}>
                                            {head.key === "Attachment" ? (
                                              <td>
                                                <div style={{ display: "flex", alignItems: "center", gap: "8px" ,justifyContent:"center"}}>
                                                  {!hasUploadedFile && existingFile && existingFile.length > 2 && (
                                                    <>
                                                    <i
                                                      className=""
                                                      style={{
                                                        color: "#007bff", 
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={() => handleEyeClick(existingFile,row.id)}
                                                    ><FaEye/></i>
                                                    <span style={{ fontSize: "12px", color: "#495057" }}>
                                                      ({uploadedCount})
                                                    </span>
                                                    </>
                                                  )}
                                                </div>
                                              </td>
                                            ) : head.key === "auditors_remark" ? (
                                                <td>
                                                  {Action === "Work" ?<input
                                                        type="text"
                                                        placeholder="Enter remark"
                                                        value={formValues.find(f => f.id === row.id)?.auditors_remark ?? ""}
                                                        onChange={(e) => handleRemarkChange(row.id, e.target.value)}
                                                    />:<>
                                                    {row[head.key] || "-"}
                                                    </>}
                                                    
                                                </td>
                                            ) : head.key === "status" ? (
                                                <td>
                                                {Action === "Work" ?
                                                    <select name="" id=""
                                                        onChange={(e) => handleStatusChange(row.id, e.target.value)}
                                                        value={formValues.find(f => f.id === row.id)?.status ?? ""}
                                                    >
                                                        <option value="Non-Compliance">Non-Compliance</option>
                                                        <option value="Compliance">Compliance</option>
                                                        <option value="Not-Applicable">Not-Applicable</option>
                                                    </select>
                                                  :<>
                                                  {row[head.key] || "-"}
                                                  </>}
                                                </td>
                                            ) : (
                                              <td>{row[head.key] || "-"}</td>
                                            )}
                                          </React.Fragment>
                                        ))}
                                      </tr>
                                    );
                                  })
                                                                    
                                ) : (
                                  <tr>
                                    <td colSpan="7" className="text-center text-muted fw-bold">
                                      No records available
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                          <div className="d-flex justify-content-end mt-3">
                            {/* <button type="submit" className="btn btn-primary px-4 me-4">
                              Save
                            </button> */}
                            {Action === "Work" &&
                                <>
                                <div className="">
                                    <button
                                      disabled={currentMonthIndex === 0}
                                      type="button"
                                      className="btn btn-outline-secondary me-2"
                                      onClick={() => setCurrentMonthIndex(prev => prev - 1)}
                                    >
                                      Previous
                                    </button>

                                    <button
                                      disabled={currentMonthIndex === months.length - 1}
                                      type="button"
                                      className="btn btn-sm btn-outline-secondary me-2"
                                      onClick={() => setCurrentMonthIndex(prev => prev + 1)}
                                    >
                                      Next
                                    </button>
                                  </div>
                                    <button type="submit" className="btn btn-sm btn-primary px-2 me-2" name="save">Save</button>
                                    <button type="submit" className="btn btn-sm btn-success px-2 me-2" name="submit">Complete</button>
                                </>
                            }
                            <button type="button" className="btn btn-sm btn-warning px-2 me-2" onClick={()=>{setUpdateAuditView(true)}}>
                              Extend Due Date
                            </button>
                          </div>
                        </div>
                      </form>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {updateAuditView && (
                <>
                <div className="createAuditMainContainer">
                  <div className="createAuditMainContainer-module shadow">
                    <div className="create-audit-forms-header d-flex justify-content-between">
                      <div className="div">
                        <h5>Extend Audit Due Date</h5>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                          sed do eiusmod tempor incididunt ut labore aliqua
                        </p>
                      </div>
                      <button
                        className="into-btn-icon"
                        onClick={() => setUpdateAuditView(false)}
                      >
                      <img src={intomarkIcon} alt="" />
                      </button>
                    </div>

                    <div className="create-audit-form-main-div">
                      <div className="container mt-2">
                        <div className="form-container">
                          <form onSubmit={onSubmit}>
                            
                              <>

                                <div className="row">
                                  <div className="col-md-6 mb-3">
                                    <label>Start Period <span className='text-danger'>*</span></label>
                                    <input
                                      type="month"
                                      className="form-control"
                                      value={updateForm.start_period}
                                      max={currentMonthdata}
                                      
                                      required
                                      onChange={(e) =>{
                                        setUpdateForm({ ...updateForm, start_period: e.target.value ,end_period:""});
                                      }}
                                      readOnly
                                    />
                                  </div>
                                  <div className="col-md-6 mb-3">
                                    <label>End Period <span className='text-danger'>*</span></label>
                                    <input
                                      type="month"
                                      className="form-control"
                                      value={updateForm.end_period}
                                      required
                                      onChange={(e) =>{
                                        setUpdateForm({ ...updateForm, end_period: e.target.value });
                                      }
                                      }
                                      readOnly
                                    />
                                  </div>
                                  <div className="col-md-6 mb-1">
                                    <label>Audit Name <span className='text-danger'>*</span></label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter Audit Name"
                                      value={updateForm.audit_name}
                                      onChange={(e) =>{
                                        setUpdateForm({ ...updateForm, audit_name: e.target.value });
                                      }
                                      }
                                      readOnly
                                    />
                                  </div>
                                  <div className="col-md-6 mb-1">
                                    <label>Validity Date <span className='text-danger'>*</span></label>
                                    <input
                                      type="date"
                                      className="form-control"
                                      value={updateForm.validity_date}
                                      min={today}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        setUpdateForm({ ...updateForm, validity_date: value,mail_reminder: [] });

                                        if (value) {
                                          const range = getDateRange(today, value);
                                          setRemainderDates(
                                            range.map((d) => ({
                                              label: d,
                                              value: d,
                                            }))
                                          );
                                        } else {
                                          setRemainderDates([]);
                                        }
                                      }}
                                      required
                                    />

                                  </div>
                                  <div className="col-md-12 mb-1 createAuditTemplateData">
                                    <label>Reminder Dates</label>
                                    {/* <Select
                                      isMulti
                                      options={remainderDates}
                                      value={
                                        updateForm.mail_reminder?.map((d) => ({ label: d, value: d })) || []
                                      }
                                      onChange={(selected) =>{
                                        setUpdateForm({
                                          ...updateForm,
                                          mail_reminder: selected.map((item) => item.value),
                                        })
                                      }
                                      }
                                      placeholder="Select reminder dates"
                                      // className="basic-multi-select"
                                      classNamePrefix="react-select"
                                    /> */}
                                      <MultiSelect
                                        options={remainderDates}
                                        value={updateForm.mail_reminder} 
                                        onChange={(vals) =>
                                          setUpdateForm({
                                            ...updateForm,
                                            mail_reminder: vals,
                                          })
                                        }
                                        openDropdownId={openDropdownId}
                                        setOpenDropdownId={setOpenDropdownId}
                                        placeholder="Select reminder dates"
                                        id="reminder-dates"
                                      />
                                  </div>


                                </div>

                                <div className="text-end mt-3">
                                  <button
                                    type="submit"
                                    className="btn btn-success px-4"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                </>
              )}
          
      {showModal && (
        <AttachmentViewer
          files={selectedFiles}
          fileId={fileId}
          setFiles={setSelectedFiles}
          onClose={() => setShowModal(false)}
          deletedata={false}
          showSnackbar={showSnackbar}
          setLoading={setLoading}
        />
      )}
        </div>
      </div>
      
      <Dialog
          open={openCompleteAlert}
          TransitionComponent={Transition}
          keepMounted
          aria-describedby="alert-dialog-slide-description"
      >
          <DialogTitle>{"Are you sure?"}</DialogTitle>
          <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                Are you sure you want to complete this audit? This action cannot be undone.
              </DialogContentText>
          </DialogContent>
          <DialogActions>
              <Button onClick={setOpenCompleteAlertFalse}>No</Button>
              <Button onClick={handleUpdateAuditData}>Yes</Button>
          </DialogActions>
      </Dialog>
    </div>
  )
}

export default AuditDetailsUpdate